export const getShortOrRegularTranslateKey = (
  regularTranslateKey: string,
  isSmall: boolean
): string => {
  return isSmall ? `${regularTranslateKey}_short` : regularTranslateKey;
};
